export default "__VITE_ASSET__Dw8V3Uw$__"